import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface AccountTypeInputProps {
  value?: { account_type?: string };
  onChange?: (value: { account_type: string }) => void;
  disabled?: boolean;
}

/**
 * Atomic component for Account Type selection
 * Component ID: LOS_AccountTypeInput_431
 * Getter API: LOS_GetAccountType_427
 * Setter API: LOS_SetAccountType_428
 */
const AccountTypeInput: React.FC<AccountTypeInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const currentValue = value?.account_type || 'savings';

  const handleChange = useCallback((val: string) => {
    if (onChange) {
      onChange({ account_type: val });
    }
  }, [onChange]);

  return (
    <div className="space-y-1.5">
      <Label htmlFor="account_type">
        Account Type <span className="text-red-500">*</span>
      </Label>
      <Select value={currentValue} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger id="account_type">
          <SelectValue placeholder="Select account type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="savings">Savings</SelectItem>
          <SelectItem value="current">Current</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default AccountTypeInput;
